/* eslint-disable no-tabs */
import React from 'react';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useAddToCart } from '@thd-olt-component-react/cart-common-data';
import { onApprove, createOrder } from '../utils/paypalUtils';

export function PaypalSmartButton(
  orderId, payInFour, hasSavedPaypal, cartRequest, itemCount, fromPage, ffm, paypalButtonStyle
) {
  const [addToCart] = useAddToCart();
  const buttonStyle = {
    label: paypalButtonStyle,
    color: 'gold',
    shape: 'rect',
    height: 40
  };

  const onPaypalApprove = (paypalData) => {
    return onApprove(paypalData, orderId);
  };

  const createPaypalOrder = (cartId) => {
    return createOrder(cartId, orderId, hasSavedPaypal, payInFour, fromPage, itemCount, ffm);
  };

  const addTocart = () => {
    return addToCart({ cartRequest }).then((resp) => {
      if (resp?.data?.addToCart) {
        return resp?.data?.addToCart?.cartId;
      }
      return false;
    }).then((cartId) => {
      if (cartId) {
        return createPaypalOrder(cartId);
      }
      return false;
    }).catch((error) => {
      console.log(error);
    });
  };

  const onCancel = (data) => {
    LIFE_CYCLE_EVENT_BUS.trigger('add-to-cart.success', data);
  };

  return (
    <PayPalButtons
      createOrder={cartRequest ? addTocart : createPaypalOrder}
      onApprove={onPaypalApprove}
      onCancel={onCancel}
      fundingSource={(hasSavedPaypal && payInFour) ? 'paylater' : 'paypal'}
      style={buttonStyle}
      forceReRender={[cartRequest]}
    />
  );
}